export default {
  'en': {
    helpAndSupport: 'Help and Support',
    contactUs: 'Contact us',
    ticketHeading: 'Contacts of the Сlient\'s Department',
    ticketSubHeading: 'Ask a question',
    ticketSuccess: 'Thank you for contacting us! You will be redirected to the main page in:',
    ticketName: 'Your name',
    ticketLogin: 'Login in terminal',
    ticketEmail: 'Email',
    ticketOptionGeneral: {
      value: 'General questions',
      text: 'Please, describe in details the difficulies that you are experiencing and specify your contact phone number.'
    },
    ticketOptionRecovery: {
      value: 'Login recovery',
      text: 'Please, describe in details the difficulies that you are experiencing and specify your passport or ID card data (serie, number, issued by which authority and when) please also mention 2 last financial operations that you have made on your account (deposit/withdrawal)'
    },
    ticketOptionRefill: {
      value: 'Refill of funds',
      text: 'Please, describe in details the difficulties that you are experiencing and specify the way of making deposit, its date, time and amount.'
    },
    ticketOptionWithdrawals: {
      value: 'Withdrawals',
      text: 'Please, describe in details the difficulties that you are experiencing and specify the way of withdrawal, its date, time and amount.'
    },
    ticketOptionFinancial: {
      value: 'Financial claim on trading operations on the account',
      text: 'Please, describe in details the difficulties that you are experiencing and specify the amount of the loss (in USD) and your suggestion on how to resolve the situation.'
    },
    ticketOptionClosing: {
      value: 'Closing of account',
      text: 'Please, describe in details the difficulies that you are experiencing and specify your passport or ID card data (serie, number, issued by which authority and when).'
    },
    ticketSubject: 'Subject',
    ticketDescription: 'Description',
    ticketAttachCaption: 'Attach a file',
    ticketAttachMultipleCaption: 'Files attached:',
    ticketSubmit: 'Submit'
  },
  'ru-RU': {
    helpAndSupport: 'Центр поддержки',
    contactUs: 'Связаться с нами',
    ticketHeading: 'Контакты Департамента по работе с Клиентами',
    ticketSubHeading: 'Задать вопрос специалисту',
    ticketSuccess: 'Благодарим за обращение! Вы будете перенаправлены на главную страницу через:',
    ticketName: 'Ваше имя',
    ticketLogin: 'Номер счета',
    ticketEmail: 'Email',
    ticketOptionGeneral: {
      value: 'Общие вопросы',
      text: 'Пожалуйста, детально опишите ваше затруднение и укажите номер телефона для связи.'
    },
    ticketOptionRecovery: {
      value: 'Восстановление логина и пароля',
      text: 'Пожалуйста, детально опишите ваше затруднение и укажите данные Вашего паспорта или ID (серия, номер, когда и кем выдан) и укажите 2 последние финансовые операции по счету (пополнение/снятие).'
    },
    ticketOptionRefill: {
      value: 'Зачисление денежных средств',
      text: 'Пожалуйста, детально опишите ваше затруднение и укажите способ пополнения, дату, время и сумму платежа.'
    },
    ticketOptionWithdrawals: {
      value: 'Снятие денежных средств',
      text: 'Пожалуйста, детально опишите ваше затруднение и укажите способ вывода средств, дату, время и сумму платежа.'
    },
    ticketOptionFinancial: {
      value: 'Финансовая претензия по торговым операциям на счете',
      text: 'Пожалуйста, детально опишите ваше затруднение и  укажите сумму убытка (в USD) и ваш вариант разрешения ситуации.'
    },
    ticketOptionClosing: {
      value: 'Удаление личного кабинета',
      text: 'Пожалуйста, детально опишите ваше затруднение и укажите данные Вашего паспорта или ID (серия, номер, когда и кем выдан).'
    },
    ticketSubject: 'Тема',
    ticketDescription: 'Описание ситуации',
    ticketAttachCaption: 'Прикрепить файл',
    ticketAttachMultipleCaption: 'Прикреленных файлов:',
    ticketSubmit: 'Отправить'
  },
  'zh-CN': {
    helpAndSupport: '帮助与支持',
    contactUs: '联系我们',
    ticketHeading: '客服部门联系方式',
    ticketSubHeading: '提一个问题',
    ticketSuccess: '感谢与我们取得联系！ 您将重新跳转回到主页：',
    ticketName: '姓名',
    ticketLogin: '账号',
    ticketEmail: 'Email',
    ticketOptionGeneral: {
      value: '常见问题',
      text: '请详细描述您遭遇的难题，并留下您的电话号码。'
    },
    ticketOptionRecovery: {
      value: '恢复登录',
      text: '请详细描述您遭遇的难题，并说明您的护照或身份证信息（编号、签发机构和日期）。也请提及您在账户上进行的最后两项操作（存款/提款）。'
    },
    ticketOptionRefill: {
      value: '再次入金',
      text: '请详细描述您遭遇的难题，并说明您存款的方式、日期、时间和金额。'
    },
    ticketOptionWithdrawals: {
      value: '出金',
      text: '请详细描述您遭遇的难题，并说明您提款的方式、日期、时间和金额。'
    },
    ticketOptionFinancial: {
      value: '账户交易业务的金融债券',
      text: '请详细描述您遭遇的难题，并（以美元）说明您亏损的金额和建议如何解决此类问题。'
    },
    ticketOptionClosing: {
      value: '关闭账户',
      text: '请详细描述您遭遇的难题，并说明您的护照或身分证信息（编号、签发机构和日期）。'
    },
    ticketSubject: '留言主题',
    ticketDescription: '问题描述',
    ticketAttachCaption: '添加文件',
    ticketSubmit: '提交'
  },
  'zh-TW': {
    helpAndSupport: '幫助與支持',
    contactUs: '聯繫我們',
    ticketHeading: '客服部門聯繫方式',
    ticketSubHeading: '提一個問題',
    ticketSuccess: '感謝您聯絡我們！ 您將被重新導向如下主頁：',
    ticketName: '姓名',
    ticketLogin: '帳戶號碼',
    ticketEmail: 'Email',
    ticketOptionGeneral: {
      value: '常見問題',
      text: '請詳細描述您遇到的疑難問題，並說明您的電話號碼。'
    },
    ticketOptionRecovery: {
      value: '恢復登錄',
      text: '請詳細描述您遇到的疑難問題，並指定您的護照或身分證信息（編號、簽發機構和日期），也請提及您在賬戶上進行的最新的兩項操作（入金/出金）。'
    },
    ticketOptionRefill: {
      value: '再次入金',
      text: '請詳細描述您遇到的疑難問題，並指定您入金的方式、日期、時間以及金額。'
    },
    ticketOptionWithdrawals: {
      value: '出金',
      text: '請詳細描述您遇到的疑難問題，並指定您出金的方式、日期、時間以及金額。'
    },
    ticketOptionFinancial: {
      value: '賬戶交易業務的金融債券',
      text: '請詳細描述您遇到的疑難問題，並（以美元）指定您虧損的金額以及您關於如何解決此類問題的建議。'
    },
    ticketOptionClosing: {
      value: '關閉賬戶',
      text: '請詳細描述您遇到的疑難問題，並指定您的護照或身分證信息（編號、簽發機構和日期）。'
    },
    ticketSubject: '留言主題',
    ticketDescription: '問題描述',
    ticketAttachCaption: '附加一個檔案',
    ticketSubmit: '建立'
  },
  'id': {
    helpAndSupport: 'Bantuan dan Dukungan',
    contactUs: 'Hubungi kami',
    ticketHeading: 'Kontak Departemen Layanan Pelanggan',
    ticketSubHeading: 'Mengajukan pertanyaan',
    ticketSuccess: 'Terima kasih telah menghubungi kami! Anda akan diarahkan ke halaman utama dalam:',
    ticketName: 'Nama Anda',
    ticketLogin: 'Nomor akun',
    ticketEmail: 'Email',
    ticketOptionGeneral: {
      value: 'Pertanyaan umum',
      text: 'Harap deskripsikan secara mendetail mengenai kesulitan yang Anda alami dan cantumkan nomor telepon Anda yang dapat dihubungi.'
    },
    ticketOptionRecovery: {
      value: 'Pemulihan login',
      text: 'Harap deskripsikan secara mendetail mengenai kesulitan yang Anda alami dan cantumkan data paspor atau kartu identitas Anda (nomor kartu, institusi penerbit, tanggal penerbitan) dan sebutkan pula 2 transaksi finansial terakhir yang Anda lakukan di akun Anda (deposit/penarikan dana).'
    },
    ticketOptionRefill: {
      value: 'Isi ulang dana',
      text: 'Harap deskripsikan secara mendetail mengenai kesulitan yang Anda alami dan cantumkan cara Anda membuat deposit, tanggal, waktu, dan nilai deposit.'
    },
    ticketOptionWithdrawals: {
      value: 'Penarikan',
      text: 'Harap deskripsikan secara mendetail mengenai kesulitan yang Anda alami dan cantumkan cara penarikan dana, tanggal, waktu, dan nilai penarikan.'
    },
    ticketOptionFinancial: {
      value: 'Klaim keuangan pada akun operasional perdagangan',
      text: 'Harap deskripsikan secara mendetail mengenai kesulitan yang Anda alami dan cantumkan nominal kerugian (dalam USD) dan saran Anda untuk mengatasi situasi ini.'
    },
    ticketOptionClosing: {
      value: 'Penutupan akun',
      text: 'Harap deskripsikan secara mendetail mengenai kesulitan yang Anda alami dan cantumkan data paspor atau kartu identitas Anda (nomor kartu, institusi penerbit, tanggal penerbitan).'
    },
    ticketSubject: 'Subjek pesan',
    ticketDescription: 'Deskripsi Tiket',
    ticketAttachCaption: 'Lampirkan file',
    ticketSubmit: 'Mengajukan'
  },
  'pt-BR': {
    helpAndSupport: 'Ajuda e Suporte',
    contactUs: 'Contacte-nos',
    ticketHeading: 'Formulário de contato',
    ticketSubHeading: 'Faça uma pergunta',
    ticketSuccess: 'Obrigado por nos contatar! Você vai ser redirecionado para a página principal em:',
    ticketName: 'Seu nome',
    ticketLogin: 'Número de conta',
    ticketEmail: 'Email',
    ticketOptionGeneral: {
      value: 'Perguntas gerais',
      text: 'Por favor, descreva em detalhe as dificuldades que está sentindo especifique o seu número de telefone de contato.'
    },
    ticketOptionRecovery: {
      value: 'Recuperação de Login',
      text: 'Por favor, descreva em detalhes as dificuldades que está sentindo e especifique seus dados de passaporte ou cartão de ID (série, número, emitido por qual autoridade e quando) por favor, mencione as 2 últimas operações financeiras que efetuou em sua conta (depósito/retirada).'
    },
    ticketOptionRefill: {
      value: 'Recarga de fundos',
      text: 'Por favor, descreva em detalhe as dificuldades que está sentindo e especifique a forma de fazer depósito, a sua data, hora e montante.'
    },
    ticketOptionWithdrawals: {
      value: 'Saques',
      text: 'Por favor, descreva em detalhe as dificuldades que está sentindo e especifique a forma de fazer retirada, sua data, hora e montante.'
    },
    ticketOptionFinancial: {
      value: 'Operações de crédito financeiro na negociação sobre a conta',
      text: 'Por favor, descreva em detalhe as dificuldades que está sentindo e especifique o montante da perda (em USD) e sua sugestão sobre como resolver a situação.'
    },
    ticketOptionClosing: {
      value: 'Encerramento de Conta',
      text: 'Por favor, descreva em detalhe as dificuldades que está sentindo e especifique seus dados de passaporte ou ID (série, número, emitido por qual autoridade e quando).'
    },
    ticketSubject: 'Assunto da mensagem',
    ticketDescription: 'Descrição',
    ticketAttachCaption: 'Anexar arquivo',
    ticketSubmit: 'Enviar'
  },
  'cs': {
    helpAndSupport: 'Zákaznická podpora',
    contactUs: 'Kontaktujte nás',
    ticketHeading: 'Kontakty z oddělení zákaznické podpory',
    ticketSubHeading: 'Zeptejte se',
    ticketSuccess: 'Děkujeme vám, že jste nás kontaktovali! Budet přesměrováni na hlavní stránku za:',
    ticketName: 'Vaše jméno',
    ticketLogin: 'Číslo účtu',
    ticketEmail: 'Email',
    ticketOptionGeneral: {
      value: 'Obecné dotazy',
      text: 'Prosím podrobně popište problémy, se kterými se potýkáte a uveďte vaše telefonní číslo.'
    },
    ticketOptionRecovery: {
      value: 'Obnovení přihlašovacích údajů',
      text: 'Prosím podrobně popište problémy, se kterými potýkáte a uveďte údaje vašeho pasu nebo občanského průkazu (série, číslo, kterým úřadem byl vydaný a kdy). Prosím uveďte také 2 poslední finanční operace, které jste provedli na vašem účtu (vklad/výběr).'
    },
    ticketOptionRefill: {
      value: 'Doplnění finančních prostředků',
      text: 'Prosím podrobně popište problémy, se kterými potýkáte a uveďte jaký způsobem jste provedli vklad včetně data a částky.'
    },
    ticketOptionWithdrawals: {
      value: 'Výběry',
      text: 'Prosím podrobně popište problémy, se kterými potýkáte a uveďte jaký způsobem jste provedli vklad včetně data a částky.'
    },
    ticketOptionFinancial: {
      value: 'Finanční nárok na obchodní operace na účtu',
      text: 'Prosím podrobně popište problémy, se kterými potýkáte a uveďte výši ztráty (v USD) a jak by se podle vás měla situace vyřešit.'
    },
    ticketOptionClosing: {
      value: 'Uzavření účtu',
      text: 'Prosím podrobně popište problémy, se kterými potýkáte a uveďte údaje vašeho pasu nebo občanského průkazu (série, číslo, kterým úřadem byl vydaný a kdy).'
    },
    ticketSubject: 'Předmět zprávy',
    ticketDescription: 'Popis problému',
    ticketAttachCaption: 'Přiložit soubor',
    ticketSubmit: 'Odeslat'
  },
  'da': {
    helpAndSupport: 'Hjælp og support',
    contactUs: 'Kontakt os',
    ticketHeading: 'Kontaktoplysninger til kundeserviceafdelingen',
    ticketSubHeading: 'Stil et spørgsmål',
    ticketSuccess: 'Tak fordi du kontaktede os! Du vil blive omdirigeret til hovedsiden om:',
    ticketName: 'Dit navn',
    ticketLogin: 'Kontonummer',
    ticketEmail: 'Email',
    ticketOptionGeneral: {
      value: 'Generelle spørgsmål',
      text: 'Beskriv venligst i detaljer, de problemer som du oplever og angiv dit kontakt telefonnummer.'
    },
    ticketOptionRecovery: {
      value: 'Login-gendannelse',
      text: 'Beskriv venligst i detaljer, de problemer som du oplever og angiv dit pas eller ID-kort oplysninger (serienummer, udstedelsesmyndighed og hvornår) angiv venligst også de sidste 2 finansielle handlinger som du foretog på din konto (indbetaling/udbetaling).'
    },
    ticketOptionRefill: {
      value: 'Pengestrøm',
      text: 'Beskriv venligst i detaljer, de problemer som du oplever og angiv måden du foretager en indbetaling, dato, tid og beløb.'
    },
    ticketOptionWithdrawals: {
      value: 'Udbetalinger',
      text: 'Beskriv venligst i detaljer, de problemer som du oplever og angiv måden du foretager en udbetaling, dato, tid og beløb.'
    },
    ticketOptionFinancial: {
      value: 'Finansielle fordring på handelstransaktioner på kontoen',
      text: 'Beskriv venligst i detaljer, de problemer som du oplever og angiv tabsbeløbet (i USD) og dit forsag til hvordan vi kan løse problemet.'
    },
    ticketOptionClosing: {
      value: 'Lukning af konto',
      text: 'Beskriv venligst i detaljer, de problemer som du oplever og angiv dit pas eller ID-kort oplysninger (serienummer, udstedelsesmyndighed og hvornår).'
    },
    ticketSubject: 'Meddelelsesemne',
    ticketDescription: 'Billetbeskrivelse',
    ticketAttachCaption: 'Vedhæft fil',
    ticketSubmit: 'Sende'
  },
  'fr': {
    helpAndSupport: 'Aide et assistance',
    contactUs: 'Contactez-nous',
    ticketHeading: 'Contacts du Service Client',
    ticketSubHeading: 'Posez une question',
    ticketSuccess: 'Merci de nous avoir contacté ! Vous serez redirigé vers la page d\'accueil en :',
    ticketName: 'Votre nom',
    ticketLogin: 'Numéro de compte',
    ticketEmail: 'Email',
    ticketOptionGeneral: {
      value: 'Questions générales',
      text: 'Veuillez décrire en détail les difficultés que vous rencontrez et préciser votre numéro de téléphone.'
    },
    ticketOptionRecovery: {
      value: 'Récupération d\'identifiant',
      text: 'Veuillez décrire en détail les difficultés que vous rencontrez et spécifier vos données de passeport ou de carte d\'identité (série, numéro, émise par quelle autorité et quand). Veuillez également mentionner les 2 dernières opérations financières que vous avez effectué sur votre compte (dépôt / retrait).'
    },
    ticketOptionRefill: {
      value: 'Circulation des fonds',
      text: 'Veuillez décrire en détail les difficultés que vous rencontrez et préciser la moyen d\'effectuer un dépôt, sa date, son heure et son montant.'
    },
    ticketOptionWithdrawals: {
      value: 'Retraits',
      text: 'Veuillez décrire en détail les difficultés que vous rencontrez et préciser la moyen de retrait, sa date, son heure et son montant.'
    },
    ticketOptionFinancial: {
      value: 'Réclamation financière sur les opérations commerciales sur le compte',
      text: 'Veuillez décrire en détail les difficultés que vous rencontrez et spécifier le montant de la perte (en USD) ainsi que votre suggestion sur la façon de résoudre la situation.'
    },
    ticketOptionClosing: {
      value: 'Clôture du compte',
      text: 'Veuillez décrire en détail les difficultés que vous rencontrez et préciser les données de votre passeport ou de votre carte d’identité (série, numéro, émise par quelle autorité et quand).'
    },
    ticketSubject: 'Sujet du message',
    ticketDescription: 'Description du ticket',
    ticketAttachCaption: 'Joindre un fichier',
    ticketSubmit: 'Envoyer'
  },
  'de': {
    helpAndSupport: 'Hilfe und Support',
    contactUs: 'Kontaktieren Sie uns',
    ticketHeading: 'Kontaktdaten unserer Kundenserviceabteilung',
    ticketSubHeading: 'Stellen Sie eine Frage',
    ticketSuccess: 'Vielen Dank für Ihre Kontaktaufnahme! Sie werden auf die Hauptseite weitergeleitet in:',
    ticketName: 'Ihr Name',
    ticketLogin: 'Kontonummrt',
    ticketEmail: 'Email',
    ticketOptionGeneral: {
      value: 'Allgemeine Fragen',
      text: 'Bitte beschreiben Sie die auftretenden Schwierigkeiten im Detail und geben Sie Ihre Telefonnummer an.'
    },
    ticketOptionRecovery: {
      value: 'Login-Wiederherstellung',
      text: 'Bitte beschreiben Sie die auftretenden Schwierigkeiten im Detail und geben Sie Ihre Reisepass- oder Personalausweis-Daten (Serie, Nummer, ausstellende Behörde und Ausstellungsdatum)an, nennen Sie bitte außerdem die zwei letzten Finanztransaktionen, die Sie auf Ihrem Konto getätigt haben (Ein-/Auszahlung).'
    },
    ticketOptionRefill: {
      value: 'Kapitalfluss',
      text: 'Bitte beschreiben Sie die auftretenden Schwierigkeiten im Detail und geben Sie die Art und Weise der Einzahlung, das Datum, die Uhrzeit und den Betrag an.'
    },
    ticketOptionWithdrawals: {
      value: 'Auszahlungen',
      text: 'Bitte beschreiben Sie die auftretenden Schwierigkeiten im Detail und geben Sie die Art und Weise der Auszahlung, das Datum, die Uhrzeit und den Betrag an.'
    },
    ticketOptionFinancial: {
      value: 'Finanzieller Anspruch aus Handelsgeschäften auf dem Konto',
      text: 'Bitte beschreiben Sie die auftretenden Schwierigkeiten im Detail und geben Sie den Betrag des Verlustes (in USD) und Ihren Vorschlag zur Lösung des Problems an.'
    },
    ticketOptionClosing: {
      value: 'Schließen des Kontos',
      text: 'Bitte beschreiben Sie die auftretenden Schwierigkeiten im Detail und geben Sie Ihre Reisepass- oder Personalausweis-Daten (Serie, Nummer, ausstellende Behörde und Ausstellungsdatum)an.'
    },
    ticketSubject: 'Betreff der Nachricht',
    ticketDescription: 'Ticket-Beschreibung',
    ticketAttachCaption: 'Datei anhängen',
    ticketSubmit: 'Senden'
  },
  'hu': {
    helpAndSupport: 'Súgó és támogatás',
    contactUs: 'Kapcsolat',
    ticketHeading: 'Az ügyfélszolgálat elérhetőségei',
    ticketSubHeading: 'Kérdezzen',
    ticketSuccess: 'Köszönjük, hogy felkeresett minket! Átirányítjuk a főoldalra itt:',
    ticketName: 'Az Ön neve',
    ticketLogin: 'Számlaszám',
    ticketEmail: 'Email',
    ticketOptionGeneral: {
      value: 'Általános kérdések',
      text: 'Kérjük, részletesen írja le a tapasztalt problémákat, és adja meg telefonszámát.'
    },
    ticketOptionRecovery: {
      value: 'Felhasználónév helyreállítása',
      text: 'Kérjük, részletesen írja le a tapasztalt problémákat, és adja meg útlevelének vagy személyigazolványának adatait (sorozat, szám, kiállító hatóság, kiállítás dátuma); írja le a számláján végzett legutóbbi 2 pénzügyi műveletet (befizetés/kifizetés).'
    },
    ticketOptionRefill: {
      value: 'Tőkefeltöltés',
      text: 'Kérjük, részletesen írja le a tapasztalt problémákat, és adja meg a befizetés módját, dátumát, időpontját és összegét.'
    },
    ticketOptionWithdrawals: {
      value: 'Kifizetések',
      text: 'Kérjük, részletesen írja le a tapasztalt problémákat, és adja meg a kifizetés módját, dátumát, időpontját és összegét.'
    },
    ticketOptionFinancial: {
      value: 'Pénzügyi követelés a számlán végzett kereskedésből eredően',
      text: 'Kérjük, részletesen írja le a tapasztalt problémákat, és adja meg a veszteség összegét (USD-ban), valamint az Ön által javasolt megoldást.'
    },
    ticketOptionClosing: {
      value: 'Számla bezárása',
      text: 'Kérjük, részletesen írja le a tapasztalt problémákat, és adja meg útlevelének vagy személyigazolványának adatait (sorozat, szám, kiállító hatóság, kiállítás dátuma).'
    },
    ticketSubject: 'Üzenet tárgya',
    ticketDescription: 'Jegy leírása',
    ticketAttachCaption: 'Fájl csatolása',
    ticketSubmit: 'Küldés'
  },
  'it': {
    helpAndSupport: 'Aiuto e supporto',
    contactUs: 'Contattaci',
    ticketHeading: 'Contatti del reparto assistenza clienti',
    ticketSubHeading: 'Fare una domanda',
    ticketSuccess: 'Grazie per averci contattato! Verrai reindirizzato alla pagina principale tra:',
    ticketName: 'Il tuo nome',
    ticketLogin: 'Numero di conto',
    ticketEmail: 'Email',
    ticketOptionGeneral: {
      value: 'Domande generali',
      text: 'Per favore, descrivi dettagliatamente le difficoltà che stai riscontrando ed indica il tuo numero di telefono.'
    },
    ticketOptionRecovery: {
      value: 'Recupero credenziali di accesso',
      text: 'Per favore, descrivi dettagliatamente le difficoltà che stai riscontrando ed indica i dati del tuo passaporto o della carta d\'identità (serie, numero, rilasciato da quale autorità e quando), per favore, menziona anche le ultime 2 transazioni finanziarie che hai effettuato sul tuo conto (deposito/prelievo).'
    },
    ticketOptionRefill: {
      value: 'Ricarica fondi',
      text: 'Per favore, descrivi dettagliatamente le difficoltà che stai riscontrando ed indica la modalità con la quale hai effettuato il deposito, la sua data, l\'ora e l\'importo.'
    },
    ticketOptionWithdrawals: {
      value: 'Prelievi',
      text: 'Per favore, descrivi dettagliatamente le difficoltà che stai riscontrando ed indica la modalità con la quale hai effettuato il prelievo, la sua data, l\'ora e l\'importo.'
    },
    ticketOptionFinancial: {
      value: 'Credito finanziario sulle operazioni di trading sul conto',
      text: 'Per favore, descrivi dettagliatamente le difficoltà che stai riscontrando ed indica l\'importo della perdita (in USD) e un tuo suggerimento su come risolvere la situazione.'
    },
    ticketOptionClosing: {
      value: 'Chiusura del conto',
      text: 'Per favore, descrivi dettagliatamente le difficoltà che stai riscontrando ed indica i dati del tuo passaporto o della carta d\'identità (serie, numero, rilasciato da quale autorità e quando).'
    },
    ticketSubject: 'Oggetto del messaggio',
    ticketDescription: 'Descrizione del ticket',
    ticketAttachCaption: 'Allega un file',
    ticketSubmit: 'Invia'
  },
  'pl': {
    helpAndSupport: 'Pomoc i wsparcie',
    contactUs: 'Skontaktuj się z nami',
    ticketHeading: 'Kontakty działu obsługi klienta',
    ticketSubHeading: 'Zadaj pytanie',
    ticketSuccess: 'Dziękujemy za skontaktowanie się z nami! Zostaniesz przekierowany/a na stronę główną za:',
    ticketName: 'Twoje imię i nazwisko',
    ticketLogin: 'Numer rachunku',
    ticketEmail: 'Email',
    ticketOptionGeneral: {
      value: 'Pytania ogólne',
      text: 'Proszę opisać szczegółowo trudności, których doświadczasz i podać swój numer telefonu kontaktowego.'
    },
    ticketOptionRecovery: {
      value: 'Odzyskanie hasła',
      text: 'Proszę szczegółowo opisać trudności, jakich doświadczasz i podać dane paszportu lub dowodu osobistego (seria, numer, organ i data wydania), proszę również podać 2 ostatnie operacje finansowe, które wykonałeś/aś na swoim rachunku (wpłata/wypłata).'
    },
    ticketOptionRefill: {
      value: 'Przelew środków',
      text: 'Proszę szczegółowo opisać trudności, z jakimi się zmagasz i określić sposób dokonania wpłaty, jej datę, godzinę i kwotę.'
    },
    ticketOptionWithdrawals: {
      value: 'Wypłaty',
      text: 'Proszę szczegółowo opisać trudności, z jakimi się zmagasz i określić sposób dokonania wypłaty, jej datę, godzinę i kwotę.'
    },
    ticketOptionFinancial: {
      value: 'Reklamacja finansowa dotyczące operacji na koncie',
      text: 'Proszę szczegółowo opisać trudności, z jakimi się zmagasz i określić kwotę straty (w USD) oraz podać swoją sugestię rozwiązania tej sytuacji.'
    },
    ticketOptionClosing: {
      value: 'Zamknięcie konta',
      text: 'Proszę szczegółowo opisać trudności, jakich doświadczasz i podać dane paszportu lub dowodu osobistego (seria, numer, organ i data wydania).'
    },
    ticketSubject: 'Temat wiadomości',
    ticketDescription: 'Opis zgłoszenia',
    ticketAttachCaption: 'Dołącz plik',
    ticketSubmit: 'Wyślij'
  },
  'pt-PT': {
    helpAndSupport: 'Ajuda e Suporte',
    contactUs: 'Contacte-nos',
    ticketHeading: 'Contatos da Área de Serviço ao Cliente',
    ticketSubHeading: 'Faça uma pergunta',
    ticketSuccess: 'Obrigado por nos contactar! Vai ser redireccionado para a página principal em:',
    ticketName: 'Seu nome',
    ticketLogin: 'Número de conta',
    ticketEmail: 'Email',
    ticketOptionGeneral: {
      value: 'Perguntas Gerais',
      text: 'Por favor, descreva em detalhe as diferenças que está a experienciar especifique o seu número de telefone de contacto.'
    },
    ticketOptionRecovery: {
      value: 'Recuperar Login',
      text: 'Por favor, descreva em detalhesas diferenças que está a experienciar e especifique os seus dados de passaporte ou cartão de ID (série, número, emitido por qual autoridade e quando) por favor, mencione as 2 últimas operações financeiras que efectuou na sua conta (depósito/levantamento).'
    },
    ticketOptionRefill: {
      value: 'Reposição de fundos',
      text: 'Por favor, descreva em detalhe as dificuldades que está a experienciar e especifique a forma de fazer depósito, a sua data, hora e montante.'
    },
    ticketOptionWithdrawals: {
      value: 'Retiradas',
      text: 'Por favor, descreva em detalhe as dificuldades que está a experienciar e especifique a forma de fazer levantamento, a sua data, hora e montante.'
    },
    ticketOptionFinancial: {
      value: 'Compromisso financeiro nas operações da conta',
      text: 'Por favor, descreva em detalhe as dificuldades que está a experienciar e especifique o montante da perda (em USD) e a sua sugestão sobre como resolver a situação.'
    },
    ticketOptionClosing: {
      value: 'Fechando a conta',
      text: 'Por favor, descreva em detalhe as dificuldades que está a experienciar e especifique os seus dados de passaporte ou ID (série, número, emitido por qual autoridade e quando).'
    },
    ticketSubject: 'Assunto da mensagem',
    ticketDescription: 'Descrição do Protocolo',
    ticketAttachCaption: 'Anexar arquivo',
    ticketSubmit: 'Enviar'
  },
  'ro': {
    helpAndSupport: 'Ajutor și asistență',
    contactUs: 'Contactați-ne',
    ticketHeading: 'Contacte din Departamentul de Asistență clienți',
    ticketSubHeading: 'Adresează o întrebare',
    ticketSuccess: 'Mulțumim că ne-ați contactat! Veți fi redirecționat la pagina principală în:',
    ticketName: 'Numele tau',
    ticketLogin: 'Numărul contului',
    ticketEmail: 'Email',
    ticketOptionGeneral: {
      value: 'Întrebari generale',
      text: 'Vă rugăm, descrieți detaliat dificultățile pe care le întâmpinați și specificați numărul dvs. de telefon.'
    },
    ticketOptionRecovery: {
      value: 'Recuperare date de conectare',
      text: 'Vă rugăm, descrieți detaliat dificultățile pe care le întâmpinați și specificați datele din pașaportul sau cartea dvs. de identitate (serie, număr, eliberat de ce autoritate și la ce dată). Menționați, de asemenea, ultimele 2 operațiuni financiare pe care le-ați efectuat în contul dvs. (depunere/retragere).'
    },
    ticketOptionRefill: {
      value: 'Realimentarea fondurilor',
      text: 'Vă rugăm, descrieți detaliat dificultățile pe care le întâmpinați și specificați modul în care ați efectuat depunerea, data, ora și suma.'
    },
    ticketOptionWithdrawals: {
      value: 'Retrageri',
      text: 'Vă rugăm, descrieți detaliat dificultățile pe care le întâmpinați și specificați modul în care ați efectuat retragerea, data, ora și suma.'
    },
    ticketOptionFinancial: {
      value: 'Creanțe financiare asupra operațiunilor de tranzacționare pe cont',
      text: 'Vă rugăm, descrieți detaliat dificultățile pe care le întâmpinați și specificați suma pierdută (în USD) și sugestia dvs. cu privire la modul de rezolvare a situației.'
    },
    ticketOptionClosing: {
      value: 'Închiderea contului',
      text: 'Vă rugăm, descrieți detaliat dificultățile pe care le întâmpinați și specificați datele din pașaportul sau cartea dvs. de identitate (serie, număr, eliberat de ce autoritate și la ce dată).'
    },
    ticketSubject: 'Subiectul mesajului',
    ticketDescription: 'Descrierea tichetului',
    ticketAttachCaption: 'Incarca un fisier',
    ticketSubmit: 'Trimite'
  },
  'sk': {
    helpAndSupport: 'Pomoc a podpora',
    contactUs: 'Kontaktujte nás',
    ticketHeading: 'Kontakty na Oddelenie služieb zákazníkom',
    ticketSubHeading: 'Spýtajte sa otázku',
    ticketSuccess: 'Ďakujeme, že ste nás kontaktovali! Budete presmerovaní na hlavnú stránku:',
    ticketName: 'Tvoje meno',
    ticketLogin: 'Číslo účtu',
    ticketEmail: 'Email',
    ticketOptionGeneral: {
      value: 'Všeobecné otázky',
      text: 'Opíšte, prosím, podrobne ťažkosti, s ktorými ste sa stretli  a zadajte vaše telefónne číslo, na ktorom vás zastihneme.'
    },
    ticketOptionRecovery: {
      value: 'Obnovenie prihlasovacieho mena',
      text: 'Opíšte, prosím, podrobne ťažkosti, s ktorými ste sa stretli a zadajte údaje z vášho pasu alebo alebo občianskeho preukazu (séria, číslo, ktorý orgán ho vydal a kedy.) Uveďte tiež 2 posledné finančné operácie, ktoré ste vykonali na svojom účte (vklad/výber).'
    },
    ticketOptionRefill: {
      value: 'Doplnenie finančných prostriedkov',
      text: 'Opíšte, prosím, podrobne ťažkosti, ktoré zažívate a popíšte spôsob, akým ste robili vklad, dátum vkladu, čas a sumu.'
    },
    ticketOptionWithdrawals: {
      value: 'Výbery',
      text: 'Opíšte, prosím, podrobne ťažkosti, ktoré zažívate a popíšte spôsob, akým ste robili výber, dátum vkladu, čas a sumu.'
    },
    ticketOptionFinancial: {
      value: 'Finančná požiadavka na obchodné operácie na účte',
      text: 'Opíšte, prosím, ťažkosti, ktoré ste mali a uveďte výšku straty (v USD) a váš návrh, ako situáciu riešiť.'
    },
    ticketOptionClosing: {
      value: 'Zatvorenie účtu',
      text: 'Opíšte, prosím, podrobne ťažkosti, ktoré ste mali a zadajte údaje z vášho pasu alebo občianskeho preukazu (séria, číslo, dátum vydania a kto ho vydal).'
    },
    ticketSubject: 'Predmet správy',
    ticketDescription: 'Popis ticketu',
    ticketAttachCaption: 'Priložiť súbor',
    ticketSubmit: 'Odoslať'
  },
  'sv-SE': {
    helpAndSupport: 'Hjälp och support',
    contactUs: 'Kontakta oss',
    ticketHeading: 'Kundtjänstkontakter',
    ticketSubHeading: 'Ställ en fråga',
    ticketSuccess: 'Tack för att du kontaktade oss! Du kommer att dirigeras till huvudsidan om:',
    ticketName: 'Ditt namn',
    ticketLogin: 'Kontonummer',
    ticketEmail: 'Email',
    ticketOptionGeneral: {
      value: 'Allmänna frågor',
      text: 'Beskriv detaljerat de problem du upplever och ange ditt telefonnummer om vi behöver kontakta dig.'
    },
    ticketOptionRecovery: {
      value: 'Återställning av inloggning',
      text: 'Beskriv detaljerat de problem du upplever och ange dina pass- eller ID-kortsuppgifter (serie, nummer, utfärdande myndighet och utfärdandedatum). Nämn även de senaste 2 finansiella transaktionerna som du har gjort på ditt konto (insättning/uttag).'
    },
    ticketOptionRefill: {
      value: 'Fyll på medel',
      text: 'Beskriv detaljerat de problem du upplever och ange insättningsmetod, datum, tid och belopp.'
    },
    ticketOptionWithdrawals: {
      value: 'Uttag',
      text: 'Beskriv detaljerat de problem du upplever och ange uttagsmetod, datum, tid och belopp.'
    },
    ticketOptionFinancial: {
      value: 'Finansiell fordran på kontots handelsverksamhet',
      text: 'Beskriv detaljerat de problem du upplever och ange förlustbeloppet (i USD) och ditt förslag på hur situationen bör lösas.'
    },
    ticketOptionClosing: {
      value: 'Avsluta ett konto',
      text: 'Beskriv detaljerat de problem du upplever och ange dina pass- eller ID-kortsuppgifter (serie, nummer, utfärdande myndighet och utfärdandedatum).'
    },
    ticketSubject: 'Meddelandets ämne',
    ticketDescription: 'Beskrivning av supportbegäran',
    ticketAttachCaption: 'Bifoga fil',
    ticketSubmit: 'Skicka in'
  }
}



// WEBPACK FOOTER //
// ./src/translations/index.js